/* Role hierarchy — post-pivot model with Team Lead + Viewer (Jun 2026).
   super_admin > admin > org_admin > team_lead > editor > trainer > viewer */
export const ROLES = {
  SUPER_ADMIN: 'super_admin',
  ADMIN: 'admin',
  ORG_ADMIN: 'org_admin',
  TEAM_LEAD: 'team_lead',
  EDITOR: 'editor',
  TRAINER: 'trainer',
  VIEWER: 'viewer',
  // Deprecated — kept for legacy rows / stale tokens. Treated as trainer-level.
  EDITOR_TRAINER: 'editor_trainer',
};

export const ROLE_LEVEL = {
  super_admin: 5,
  admin: 4,
  org_admin: 3,
  team_lead: 2.5,
  editor: 2,
  trainer: 1,
  viewer: 0.5,
  editor_trainer: 1,
  trainee: 0.1,
};

export const ROLE_LABELS = {
  super_admin: 'Super Admin',
  admin: 'Admin',
  org_admin: 'Org Admin',
  team_lead: 'Team Lead',
  editor: 'Editor',
  trainer: 'Trainer',
  viewer: 'Viewer',
  editor_trainer: 'Editor / Trainer',  // deprecated label, shown only on legacy rows
};

export const STATUS_LABELS = {
  not_started: 'Not Started',
  in_progress: 'In Progress',
  completed: 'Completed',
  failed: 'Failed',
  expired: 'Expired',
};
